// extracted by mini-css-extract-plugin
export var container = "wzmrNb3MOQ6FmXGH_plm";
export var footer = "pGyc5dam6mktUwYw7QI5";
export var header = "zVWfO4n0rDpJ7ZhMP2EX";
export var main = "i4B1rupVWJ5oLEJ4VQmz";
export var root = "j5L1JLgTdfeTdJR67Kpu";
export var sidebar = "wmNLQPleJtOzsxBosjhY";